<template>
  <FormContainer withoutDivider>
    <template #title>Informations salarié(e)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_123"
          :model-value="salariéEnCours?.nomNaissance"
          @update:model-value="(value: any) => updateModule('nomNaissance', activeSalariéIndex!, value)"
          label="Nom de naissance"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM"
          :required="metaSalarieEnCours?.nomNaissance?.$status === PropertyStatus.Required"
          :alertLabel="metaSalarieEnCours?.nomNaissance?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />

        <WrapperInput
          id="field_125"
          :model-value="salariéEnCours?.prenom"
          @update:model-value="(value: any) => updateModule('prenom', activeSalariéIndex!, value)"
          label="Prénom"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :required="metaSalarieEnCours?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="metaSalarieEnCours?.prenom?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperDropdown
          id="field_127"
          key="sexe-dropdown"
          :model-value="salariéEnCours?.sexe"
          @update:model-value="(value: any) => updateModule('sexe', activeSalariéIndex!, value)"
          label="Sexe"
          class="col-7 col-md-12 col-sm-36"
          :items="sexeItems"
          :readonly
          :required="metaSalarieEnCours?.sexe?.$status === PropertyStatus.Required"
          :alertLabel="metaSalarieEnCours?.sexe?.$messageErreurDirty!"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { SalarieActionKey, type SalarieAction } from '@/features/interface/demande/af/steps/salarie/useSalarieActions'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { FormContainer, PLACEHOLDER_NOM, PLACEHOLDER_PRENOM } from '@/features/interface/demande/shared'
  import type { SalarieDTO } from '@/features/api/extranet/dto/Demande/AF'
  import { sexeItems } from '@/features/interface/shared/tools'

  const store = useDemandeAFStore()
  const { setupArrayUpdaterWithKey } = store

  const { readonly } = storeToRefs(store)
  const { activeSalariéIndex, salariéEnCours, metaSalarieEnCours } = inject<SalarieAction>(SalarieActionKey)!

  const updateModule = setupArrayUpdaterWithKey<SalarieDTO>('salaries')
</script>
